(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.shopify-section__header');
    const miniCart = document.querySelector('.header__action-item--cart');
    const collectionFilter = document.querySelector('.collection .collection__toolbar--bordered');
    const collectionDeskFilter = document.querySelector('body.template-collection .layout .layout__section:first-child.pt-sticky');

    function calculateHeaderHeight() {
      const announcementBar = document.querySelector('.shopify-section--announcement-bar.sticky-announcement-bar'); // Announcement Bar

      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
      const headerHeight = header ? header.offsetHeight : 0;

      const totalHeaderHeight = announcementBarHeight + headerHeight;

      return {
        totalHeaderHeight: totalHeaderHeight,
        headerHeight: headerHeight,
      };
    }

    let heights = calculateHeaderHeight();
    let offsetTop = heights.totalHeaderHeight - heights.headerHeight;

    if (header) {
      header.style.setProperty('--top', offsetTop + 'px');
      miniCart.style.setProperty('--headerTotalHeight', heights.totalHeaderHeight + 'px');
      collectionFilter.style.setProperty('--headerTotalHeight', heights.totalHeaderHeight + 'px');
      collectionDeskFilter.style.setProperty('--headerTotalHeight', heights.totalHeaderHeight + 'px');
    }

    window.addEventListener('scroll', function () {
      const scrollY = window.scrollY;

      if (header) {
        if (scrollY > offsetTop) {
          header.classList.add('header-fixed');
        } else {
          header.classList.remove('header-fixed');
        }
      }
    });

    window.addEventListener('resize', function () {
      heights = calculateHeaderHeight();
      offsetTop = heights.totalHeaderHeight - heights.headerHeight;

      if (header) {
        header.style.setProperty('--top', offsetTop + 'px');
        miniCart.style.setProperty('--headerTotalHeight', heights.totalHeaderHeight + 'px');
        collectionFilter.style.setProperty('--headerTotalHeight', heights.totalHeaderHeight + 'px');
        collectionDeskFilter.style.setProperty('--headerTotalHeight', heights.totalHeaderHeight + 'px');
      }
    });
  });


// Login script
  document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;
    const b2bSection = document.querySelector(".b2b-bar-section");

    function updateMiniCartHeight() {
      // Only run if body has .logged-in
      if (!body.classList.contains("logged-in")) return;

      if (b2bSection) {
        const b2bHeight = b2bSection.offsetHeight;
        // Set CSS variable
        document.documentElement.style.setProperty("--b2b-bar-height", `${b2bHeight}px`);
      }
    }

    // Run once on load
    updateMiniCartHeight();

    // Run again on window resize
    window.addEventListener("resize", updateMiniCartHeight);

    // Optional: Watch for dynamic changes in .b2b-bar-section height
    if (window.ResizeObserver && b2bSection) {
      const observer = new ResizeObserver(updateMiniCartHeight);
      observer.observe(b2bSection);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
